import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class CookieBannerComponent extends Component {
  @tracked showBanner = false;
  @tracked customizing = false;

  @tracked analytics = false;
  @tracked ads = false;
  @tracked personalization = false;

  constructor() {
    super(...arguments);
    this.loadPreferences();
  }

  loadPreferences() {
    try {
      const saved = localStorage.getItem('cookie-consent-v2');
      if (!saved) {
        this.showBanner = true;
        return;
      }

      const prefs = JSON.parse(saved);

      // Applica preferenze locali
      this.analytics = prefs.analytics;
      this.ads = prefs.ads;
      this.personalization = prefs.personalization;

      this.updateConsentState(prefs);
    } catch (e) {
      // localStorage non disponibile (es. navigazione privata Safari, iframe cross-origin)
      this.showBanner = true;
    }
  }

  savePreferences(prefs) {
    try {
      localStorage.setItem('cookie-consent-v2', JSON.stringify(prefs));
    } catch (e) {
      // localStorage not available
    }
    this.analytics = prefs.analytics;
    this.ads = prefs.ads;
    this.personalization = prefs.personalization;
    this.updateConsentState(prefs);
  }

  updateConsentState(prefs) {
    // Funzione unificata per aggiornare lo stato di consenso di Google
    gtag('consent', 'update', {
      ad_storage: prefs.ads ? 'granted' : 'denied',
      ad_user_data: prefs.ads ? 'granted' : 'denied',
      ad_personalization: prefs.personalization ? 'granted' : 'denied',
      analytics_storage: prefs.analytics ? 'granted' : 'denied',
    });
  }

  // --- Azioni ---
  @action
  acceptAll() {
    const prefs = {
      analytics: true,
      ads: true,
      personalization: true,
    };

    this.savePreferences(prefs);
    this.showBanner = false;
  }

  @action
  rejectAll() {
    const prefs = {
      analytics: false,
      ads: false,
      personalization: false,
    };

    this.savePreferences(prefs);
    this.showBanner = false;
  }

  @action
  saveCustom() {
    const prefs = {
      analytics: this.analytics,
      ads: this.ads,
      personalization: this.personalization,
    };

    this.savePreferences(prefs);
    this.showBanner = false;
  }
}
